import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    OutlinedInput,
    ListSubheader,
    FormHelperText
} from '@mui/material';

export default function GroupedAttributeValueSelector({ attributes, onChange }) {
    const [selectedValueIds, setSelectedValueIds] = useState([]);

    const handleChange = (event) => {
        const { target: { value } } = event;
        setSelectedValueIds(value);
        onChange(value); // Notificamos al padre con el array de IDs de valores
    };

    // Aplanamos la estructura de datos para renderizarla en el Select
    const allValues = attributes.flatMap(attr => [
        // Añadimos un objeto especial para el subtítulo
        { isGroup: true, name: attr.name, id: `group-${attr.id}` },
        // Añadimos los valores reales
        ...attr.attribute_values
    ]);

    return (
        <FormControl fullWidth>
            <InputLabel id="grouped-select-label">Opciones de Variante</InputLabel>
            <Select
                labelId="grouped-select-label"
                multiple
                value={selectedValueIds}
                onChange={handleChange}
                input={<OutlinedInput label="Opciones de Variante" />}
                renderValue={(selected) => `${selected.length} opciones seleccionadas`}
            >
                {attributes.map((attribute) => [
                    // Renderizamos el subtítulo del grupo
                    <ListSubheader key={`group-${attribute.id}`}>{attribute.name}</ListSubheader>,
                    
                    // Renderizamos las opciones (valores) de ese grupo
                    ...attribute.attribute_values.map((value) => (
                        <MenuItem key={value.id} value={value.id}>
                            <Checkbox checked={selectedValueIds.indexOf(value.id) > -1} />
                            <ListItemText primary={value.value} />
                        </MenuItem>
                    ))
                ])}
            </Select>
            <FormHelperText>
                Selecciona todas las opciones que ofreces para este producto.
            </FormHelperText>
        </FormControl>
    );
}

// Definimos los propTypes para asegurar que los datos sean correctos
GroupedAttributeValueSelector.propTypes = {
    attributes: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        attribute_values: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            value: PropTypes.string.isRequired,
        })),
    })).isRequired,
    onChange: PropTypes.func.isRequired,
};